import { render, staticRenderFns } from "./CostBreakdownCategoryModal.vue?vue&type=template&id=4d584810&scoped=true&"
import script from "./CostBreakdownCategoryModal.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownCategoryModal.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownCategoryModal.vue?vue&type=style&index=0&id=4d584810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d584810",
  null
  
)

export default component.exports